import { logger } from './../constants';
export function getScriptGTM(gtmId) {
  return new Promise((resolve, reject) => {
    ((w, d, s, l, i) => {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      let r = false;
      let f = d.getElementsByTagName(s)[0];
      let j = d.createElement(s);
      let dl = l != 'dataLayer' ? '&l=' + l : '';
      j.id = 'gtm-script';
      j.type = 'text/javascript';
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      j.async = true;
      j.onerror = function (err) {
        // eslint-disable-next-line no-console
        console.error('## TagManager - loading script gtm in error', err);
        reject(err);
      };
      j.onload = function () {
        if (!r && (!this.readyState || this.readyState == 'complete')) {
          // eslint-disable-next-line no-console
          logger('## TagManager - load script gtm succesfully');
          r = true;
          resolve(i);
        }
      };
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', gtmId);
  });
}
